export default {"src":"/_next/static/media/NZ.0281dad7.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};